export default __webpack_public_path__ + "static/media/Anthony.0703aab8.jpg";